<template>
  <div class="columns is-multiline">
    <div class="column pdv-1" :class="isIndiceType ? 'is-4' : 'is-6'">
      <b-field
        :label="$t('detailContrat.indexation.typeIndexation')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ getTypeIndexationLibelle(itemIndexe.typeIndexation) }}
        </span>
      </b-field>
    </div>
    <div v-if="!forEcheancier && isIndiceType" class="column is-4 pdv-1">
      <b-field
        :label="$t('detailContrat.indexation.indiceReference')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ indice }}
        </span>
      </b-field>
    </div>
    <div
      v-if="isIndiceType"
      class="column pdv-1"
      :class="!forEcheancier && isIndiceType ? 'is-4' : 'is-8'">
      <b-field
        :label="$t('detailContrat.indexation.montantIndexationReference')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ isIndiceType ?
            func.formatDevise(itemIndexe.montantIndexationReference)
            : func.formatDevise(itemIndexe.loyerAnnuelHt)}}
        </span>
      </b-field>
    </div>
    <div v-if="isIndiceType" class="column is-4 pdv-1">
      <b-field
        :label="$t('detailContrat.indexation.valeurIndexationReference')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ itemIndexe.valeurIndexationReference }}
        </span>
      </b-field>
    </div>
    <div v-if="isIndiceType" class="column is-4 pdv-1">
      <b-field
        :label="$t('detailContrat.indexation.dateIndexationReference')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ func.formatDate(itemIndexe.dateIndexationReference) }}
          {{ trimestreReference }}
        </span>
      </b-field>
    </div>
    <div class="column pdv-1" :class="isIndiceType ? 'is-4' : 'is-6'">
      <b-field
        :label="$t('detailContrat.indexation.dateDerniereIndexation')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ func.formatDate(itemIndexe.dateDerniereIndexation) }}
        </span>
      </b-field>
    </div>
    <div v-if="forEcheancier" class="column pdv-1" :class="isIndiceType ? 'is-4' : 'is-6'">
      <b-field
        :label="isIndiceType ?
          $t('detailContrat.indexation.valeurLorsIndexation')
          : $t('detailContrat.indexation.valeurIndexationPourcentage')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ isIndiceType ?
            itemIndexe.valeurIndexationActuel
            : func.formatPercent(itemIndexe.valeurIndexationActuel)}}
        </span>
      </b-field>
    </div>
    <div v-if="forEcheancier && isIndiceType" class="column is-8 pdv-1">
      <b-field
        :label="$t('detailContrat.indexation.dateLorsIndexation')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ func.formatDate(itemIndexe.dateIndexationActuel) }}
          {{ trimestreActuel }}
        </span>
      </b-field>
    </div>
    <div v-if="forEcheancier && showDate" class="column pdv-1"
         :class="isIndiceType ? 'is-4' : 'is-6'">
      <b-field
        :label="$t('detailContrat.indexation.dateSignature')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ func.formatDate(itemIndexe.dateSignature) }}
        </span>
      </b-field>
    </div>
    <div v-if="forEcheancier && showDate" class="column pdv-1"
         :class="isIndiceType ? 'is-4' : 'is-6'">
      <b-field
        :label="$t('detailContrat.indexation.dateDebutContrat')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ func.formatDate(itemIndexe.dateDebutContrat) }}
        </span>
      </b-field>
    </div>
    <div v-if="forEcheancier && showDate" class="column pdv-1"
         :class="isIndiceType ? 'is-4' : 'is-6'">
      <b-field
        :label="$t('detailContrat.indexation.dateFinContrat')"
        custom-class="is-italic has-text-weight-light mgb-0">
        <span>
          {{ func.formatDate(itemIndexe.dateFinContrat) }}
        </span>
      </b-field>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  LISTE_TYPE_INDEXATION,
  TYPE_INDEXATION_INDICE,
} from '@/configuration/baux/contrat/contratConf';
import formatDate from '@/services/general/formatDate';
import { formatDevise } from '@/services/general/filters/formatDevise';
import formatPercent from '@/services/general/filters/formatPercent';
import messageErreur from '@/services/general/messageErreur';
import getItemIndiceValeurs from '@/services/indexation/getItemIndicesValeurs';

const IndiceEtValeur = createNamespacedHelpers('indiceEtValeur');

export default {
  props: {
    itemIndexe: {
      type: Object,
      required: true,
    },
    forEcheancier: {
      type: Boolean,
      default: false,
    },
    showDate: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      func: {
        formatDate,
        formatDevise,
        formatPercent,
      },
      indiceValeurReference: null,
      indiceValeurActuel: null,
    };
  },
  computed: {
    isIndiceType() {
      return this.itemIndexe.typeIndexation === TYPE_INDEXATION_INDICE;
    },
    ...IndiceEtValeur.mapGetters({
      IndicesEtValeurs: 'items',
    }),
    indice() {
      return this.IndicesEtValeurs.find(indice => indice.id === this.itemIndexe.indiceReferenceId)?.libelle || '';
    },
    trimestreReference() {
      const trimestre = this.indiceValeurReference?.trimestre;
      return trimestre ? ` (${trimestre})` : '';
    },
    trimestreActuel() {
      const trimestre = this.indiceValeurActuel?.trimestre;
      return trimestre ? ` (${trimestre})` : '';
    },
  },
  methods: {
    getTypeIndexationLibelle() {
      const find = LISTE_TYPE_INDEXATION
        .find(t => t.code === this.itemIndexe.typeIndexation);
      return find ? this.$t(find?.libelle) : '';
    },
    ...IndiceEtValeur.mapActions({
      actionsLoadIndiceEtValeur: 'loadIndiceEtValeur',
    }),
    getIndiceEtValeur() {
      const result = getItemIndiceValeurs(this.IndicesEtValeurs, this.itemIndexe);
      this.indiceValeurReference = result?.indiceValeurReference;
      this.indiceValeurActuel = result?.indiceValeurActuel;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.actionsLoadIndiceEtValeur({
        societeId: this.itemIndexe.societeId,
      });
      this.getIndiceEtValeur();
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>
